/// KL-4: risk group
export enum RiskGroup {
	None = 0,
	VerySmall = 1,
	Small = 2,
	Medium = 3,
	High = 4,
}
